import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { photoUrl } from "../lib/api";
import { useLang } from "../lib/i18n";
import { diffLabel, durLabel } from "../lib/labels";

export { diffLabel };

const seasonRu = { spring: "Весна", summer: "Лето", autumn: "Осень", winter: "Зима" };
const seasonEn = { spring: "Spring", summer: "Summer", autumn: "Autumn", winter: "Winter" };

export const ExcursionCard = ({ exc, index = 0 }) => {
  const { lang } = useLang();
  const num = String(index + 1).padStart(2, "0");
  const seasons = (exc.seasons || []).map((s) => (lang === "ru" ? seasonRu[s] : seasonEn[s])).join(" · ");
  const title = lang === "ru" ? exc.title_ru : exc.title_en;

  return (
    <Link to={`/excursions/${exc.slug}`} data-testid={`excursion-card-${exc.slug}`} className="group block">
      <div className="relative overflow-hidden aspect-[4/5] bg-argali-brown">
        <motion.img
          src={photoUrl(exc.hero_photo_id)}
          alt={title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(17,17,15,0.05) 40%, rgba(17,17,15,0.85))" }} />
        <div className="absolute top-5 left-5 font-serif text-3xl text-argali-ivory/90">{num}</div>
        <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
          <p className="text-[0.62rem] uppercase tracking-[0.16em] text-argali-sandstone/90 mb-1.5">{seasons}</p>
          <h3 className="font-serif text-2xl md:text-3xl leading-tight text-argali-ivory group-hover:text-argali-gold transition-colors duration-500">
            {title}
          </h3>
          <div className="flex items-center gap-3 mt-3 text-[0.68rem] uppercase tracking-[0.12em] text-argali-ivory/70">
            <span>{durLabel(exc.duration, lang)}</span>
            <span className="w-1 h-1 rounded-full bg-argali-sandstone/60" />
            <span>{diffLabel(exc.difficulty, lang)}</span>
          </div>
          <div className="flex items-center gap-2 mt-4 text-[0.68rem] uppercase tracking-[0.16em] text-argali-gold opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            {lang === "ru" ? "Открыть маршрут" : "Open route"} <ArrowRight size={14} className="btn-arrow" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ExcursionCard;
